var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 6H22.2863",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28516 6H19.7137V21.4286C19.7137 21.8832 19.5331 22.3193 19.2116 22.6408C18.8901 22.9622 18.4541 23.1429 17.9994 23.1429H5.99944C5.54479 23.1429 5.10875 22.9622 4.78726 22.6408C4.46577 22.3193 4.28516 21.8832 4.28516 21.4286V6Z",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 6.00028V5.14314C7.71484 4.00649 8.16637 2.91641 8.9701 2.11268C9.77383 1.30895 10.8639 0.857422 12.0006 0.857422C13.1372 0.857422 14.2273 1.30895 15.031 2.11268C15.8347 2.91641 16.2863 4.00649 16.2863 5.14314V6.00028",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42969 11.1455V18.0052",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5703 11.1455V18.0052",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.214ad371d90094310afbf25913f537b2.svg";
export { ForwardRef as ReactComponent };